import { ColumnTitle } from '@atoms/columnElement';
import { RenderSource } from '@atoms/dataSelectors/sourceSelector/renderSource';
import { SourceSelector } from '@atoms/dataSelectors/sourceSelector/sourceSelector';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { EditorOptions } from '@library/tableEditor/shared/editor.options';
import type { AtomModel } from '@models/atom.model';
import type { MultiSelectTableEditorColumnData } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = {
  atom: AtomModel<MultiSelectTableEditorColumnData>;
};

export const MultiSelectEditor = observer(({ atom }: Props) => (
  <EditorOptions
    additionalChildren={
      <Column $width="220px">
        <ColumnTitle>Sources options</ColumnTitle>
        <RenderSource
          id={atom.id}
          onSourceDataChange={v =>
            (atom.data.editorOptions.editors.multiselect.options.dataSourceData =
              v)
          }
          selectedDataSource={
            atom.data.editorOptions.editors.multiselect.options.dataSource
          }
          sourcesData={
            atom.data.editorOptions.editors.multiselect.options.dataSourceData
          }
        />
      </Column>
    }
    atomId={atom.id}
    onPlaceholderChange={v =>
      (atom.data.editorOptions.editors.multiselect.placeholder = v)
    }
    placeholder={atom.data.editorOptions.editors.multiselect.placeholder}
  >
    <SourceSelector
      dataSource={
        atom.data.editorOptions.editors.multiselect.options.dataSource
      }
      id={atom.id}
      onDataSourceChange={v =>
        (atom.data.editorOptions.editors.multiselect.options.dataSource = v)
      }
    />
  </EditorOptions>
));
